import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from 'core/i18n';

const { formatText } = i18n;

export const DocumentList = ({ documentsList = [], onClickDocumentItem }) => {
    const drawDocumentItems = () => {
        if (!Array.isArray(documentsList)) {
            return null;
        }

        return documentsList.map(document => {
            const { documentName, isAccepted } = document;
            const iconClass = isAccepted ? 'icons--icon-success-green-dic' : 'icons--icon-document-dic';
            const itemAcceptedClass = isAccepted ? ' documentation-doc-list-item--accepted' : '';

            return (
                <li
                    className={`documentation-doc-list-item${itemAcceptedClass}`}
                    onClick={() => onClickDocumentItem(document)}
                    key={documentName}
                >
                    <i className={iconClass}></i>
                    <span>{formatText(`precontractualDocuments-${documentName}`)}</span>
                </li>
            );
        });
    };

    return <ul className="documentation-doc-list">{drawDocumentItems()}</ul>;
};

DocumentList.propTypes = {
    documentsList: PropTypes.array,
    onClickDocumentItem: PropTypes.func,
};
